export function tableConfig({ colors }) {
    return {
        bodyRow: {
            disabled: {
                color: colors.interaction.readonly.colorDark
            }
        }
    };
}
